import React from "react";

const About = () => (
  <section className="max-w-2xl mx-auto py-12 px-4">
    <h1 className="text-3xl font-bold text-center mb-6 text-gray-900 uppercase">Sobre Aromas Datasheet</h1>
    <p className="text-lg text-gray-700 mb-4 text-center">
      Bienvenido a <span className="font-semibold text-indigo-700">Aromas Datasheet</span>, la base de datos viva y siempre actualizada de fichas técnicas de perfumes.
    </p>
    <p className="text-gray-700 mb-4">
      Nuestro proyecto nace de la pasión por el mundo de las fragancias y la necesidad de contar con información precisa, confiable y accesible sobre cada perfume. Aquí encontrarás detalles técnicos, lanzamientos recientes y datos esenciales para descubrir, comparar y elegir tu próxima esencia favorita.
    </p>
    <p className="text-gray-700 mb-4">
      Nos dedicamos a mantener la base de datos al día, incorporando constantemente nuevos lanzamientos y actualizaciones de productos, para que siempre tengas a mano la información más relevante del universo perfumista.
    </p>
    <p className="text-gray-700">
      Ya seas un entusiasta, coleccionista, profesional o simplemente curioso, <span className="font-semibold text-indigo-700">Aromas Datasheet</span> es tu aliado para explorar el arte y la ciencia detrás de cada fragancia.
    </p>
  </section>
);

export default About;
